import { useState } from 'react';
import { Page } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'services/cms/flattenContentful';

export function useContentEntriesInternal(initialItems: Array<Partial<FlatEntry<Page>>> = []) {
  const [items, setItems] = useState(initialItems);
  const [activePage, setActivePage] = useState<FlatEntry<Page> | undefined>(undefined);

  return { items, setItems, activePage, setActivePage };
}
